/* ── lost paradise theme.js ── */

// ── Mobile Nav ────────────────────────────────────────────────
function toggleMobileNav() {
  var nav = document.getElementById('mobileNav');
  var btn = document.getElementById('hamburger');
  var isOpen = nav.classList.contains('open');
  if (isOpen) {
    closeMobileNav();
  } else {
    nav.classList.add('open');
    btn.classList.add('open');
    btn.setAttribute('aria-expanded', 'true');
    nav.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
}

function closeMobileNav() {
  var nav = document.getElementById('mobileNav');
  var btn = document.getElementById('hamburger');
  nav.classList.remove('open');
  btn.classList.remove('open');
  btn.setAttribute('aria-expanded', 'false');
  nav.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

// ── Cart State ────────────────────────────────────────────────
var cartData = null;

function fetchCart() {
  return fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(data) { cartData = data; return data; });
}

function addToCart(variantId, quantity) {
  quantity = quantity || 1;
  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: quantity })
  }).then(function(r) {
    if (!r.ok) throw new Error('Could not add to cart');
    return fetchCart();
  }).then(function() {
    renderCart();
    openCart();
    showToast('Added to cart', 'Item added successfully');
  });
}

function updateCartItem(key, quantity) {
  return fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: quantity })
  }).then(function() {
    return fetchCart();
  }).then(function() {
    renderCart();
  });
}

// ── Cart UI ───────────────────────────────────────────────────
function openCart() {
  closeMobileNav();
  document.getElementById('cart-drawer').classList.add('open');
  document.getElementById('cart-overlay').classList.add('open');
  document.getElementById('cart-drawer').setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}

function closeCart() {
  document.getElementById('cart-drawer').classList.remove('open');
  document.getElementById('cart-overlay').classList.remove('open');
  document.getElementById('cart-drawer').setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

document.addEventListener('DOMContentLoaded', function() {
  var overlay = document.getElementById('cart-overlay');
  if (overlay) overlay.addEventListener('click', closeCart);
});

function formatMoney(cents) {
  return '$' + (cents / 100).toFixed(2);
}

function renderCart() {
  if (!cartData) return;
  var count = cartData.item_count;
  var FREE_SHIPPING = 7500; // cents

  // Update count badges
  document.querySelectorAll('.cart-count').forEach(function(el) {
    el.textContent = count;
    el.setAttribute('data-count', count);
  });

  // Shipping bar
  var spent = cartData.total_price;
  var pct = Math.min((spent / FREE_SHIPPING) * 100, 100);
  var fill = document.getElementById('shippingFill');
  var text = document.getElementById('shippingText');
  if (fill) fill.style.width = pct + '%';
  if (text) {
    if (spent >= FREE_SHIPPING) {
      text.textContent = '✓ Free shipping unlocked!';
      text.style.color = 'var(--green)';
    } else {
      var remaining = formatMoney(FREE_SHIPPING - spent);
      text.textContent = 'Add ' + remaining + ' more for free shipping';
      text.style.color = '';
    }
  }

  // Items
  var itemsEl = document.getElementById('cartItems');
  if (!itemsEl) return;

  if (count === 0) {
    itemsEl.innerHTML =
      '<div class="cart-empty">' +
      '<p class="cart-empty__title">your cart is empty</p>' +
      '<p class="cart-empty__sub">Discover our collection</p>' +
      '<a href="/collections/all" class="btn btn--outline" onclick="closeCart()">shop now</a>' +
      '</div>';
  } else {
    itemsEl.innerHTML = cartData.items.map(function(item) {
      return '<div class="cart-item">' +
        '<div class="cart-item__img">' +
        (item.image ? '<img src="' + item.image + '" alt="' + item.product_title + '" loading="lazy">' : '') +
        '</div>' +
        '<div>' +
        '<p class="cart-item__name">' + item.product_title.toLowerCase() + '</p>' +
        (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-item__variant">' + item.variant_title + '</p>' : '') +
        '<div class="cart-item__qty">' +
        '<button class="qty-btn" onclick="updateCartItem(\'' + item.key + '\',' + (item.quantity - 1) + ')">−</button>' +
        '<span>' + item.quantity + '</span>' +
        '<button class="qty-btn" onclick="updateCartItem(\'' + item.key + '\',' + (item.quantity + 1) + ')">+</button>' +
        '</div></div>' +
        '<div class="cart-item__price">' + formatMoney(item.final_line_price) + '</div>' +
        '</div>';
    }).join('');
  }

  var sub = document.getElementById('cartSubtotal');
  if (sub) sub.textContent = formatMoney(cartData.total_price);

  var btn = document.getElementById('checkoutBtn');
  if (btn) btn.style.display = count === 0 ? 'none' : 'flex';
}

// ── Announcement Bar ──────────────────────────────────────────
function initAnnouncementBar() {
  var msgs = document.querySelectorAll('.announcement-bar__msg');
  if (!msgs.length) return;
  var idx = 0;
  msgs[0].classList.add('active');
  setInterval(function() {
    msgs[idx].classList.remove('active');
    idx = (idx + 1) % msgs.length;
    msgs[idx].classList.add('active');
  }, 3500);
}

// ── Countdown Timer ───────────────────────────────────────────
function initCountdown(selector) {
  var el = document.querySelector(selector);
  if (!el) return;
  function tick() {
    var now = new Date();
    var target = new Date(now);
    target.setHours(23, 59, 59, 0);
    var diff = target - now;
    if (diff <= 0) return;
    var h = Math.floor(diff / 3600000);
    var m = Math.floor((diff % 3600000) / 60000);
    var s = Math.floor((diff % 60000) / 1000);
    function pad(n) { return String(n).padStart(2, '0'); }
    el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
  }
  tick();
  setInterval(tick, 1000);
}

// ── Social Proof Popup ────────────────────────────────────────
var CUSTOMERS = ['Sarah M.','James K.','Olivia R.','Emma T.','Liam C.','Ava P.','Noah B.'];
var LOCATIONS = ['New York','Los Angeles','Miami','London','Toronto','Sydney'];
var PRODUCTS  = ['rubied','titan','oasis','vamp','oxied','ignite','eclipse'];
var TIMES     = ['2 mins ago','5 mins ago','just now','8 mins ago','12 mins ago'];

function showSocialPopup() {
  var popup = document.getElementById('socialPopup');
  if (!popup) return;
  var name = CUSTOMERS[Math.floor(Math.random() * CUSTOMERS.length)];
  var loc  = LOCATIONS[Math.floor(Math.random() * LOCATIONS.length)];
  var prod = PRODUCTS[Math.floor(Math.random() * PRODUCTS.length)];
  var time = TIMES[Math.floor(Math.random() * TIMES.length)];
  var nameEl   = document.getElementById('popupName');
  var actionEl = document.getElementById('popupAction');
  var timeEl   = document.getElementById('popupTime');
  if (nameEl)   nameEl.textContent   = name + ' from ' + loc;
  if (actionEl) actionEl.textContent = 'purchased ' + prod;
  if (timeEl)   timeEl.textContent   = time;
  popup.classList.add('visible');
  setTimeout(function() { popup.classList.remove('visible'); }, 5000);
}

// ── Mobile Gallery (swipe dots) ───────────────────────────────
function initMobileGallery() {
  var slider = document.querySelector('.product-gallery__slider');
  if (!slider) return;
  var slides = slider.querySelectorAll('.product-gallery__slide');
  var dots   = document.querySelectorAll('.gallery-dot');
  if (!slides.length) return;

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        var idx = Array.from(slides).indexOf(entry.target);
        dots.forEach(function(d, i) {
          d.classList.toggle('active', i === idx);
        });
      }
    });
  }, { root: slider, threshold: 0.5 });

  slides.forEach(function(slide) { observer.observe(slide); });
  if (dots.length) dots[0].classList.add('active');
}

// ── Desktop Gallery (thumb clicks) ───────────────────────────
function initDesktopGallery() {
  var thumbs  = document.querySelectorAll('.product-gallery__thumb');
  var mainImg = document.querySelector('.product-gallery__main img');
  if (!thumbs.length || !mainImg) return;
  thumbs.forEach(function(thumb) {
    thumb.addEventListener('click', function() {
      thumbs.forEach(function(t) { t.classList.remove('active'); });
      thumb.classList.add('active');
      // data-full holds the 800x1000 URL; fall back to thumb src only if missing
      var fullSrc = thumb.getAttribute('data-full') || thumb.querySelector('img').src;
      mainImg.style.opacity = '0';
      mainImg.style.transition = 'opacity 0.2s ease';
      var newImg = new Image();
      newImg.onload = function() { mainImg.src = fullSrc; mainImg.style.opacity = '1'; };
      newImg.src = fullSrc;
    });
  });
}

// ── Sticky ATC ────────────────────────────────────────────────
function initStickyAtc() {
  var atcBtn  = document.querySelector('.product-info__atc');
  var sticky  = document.getElementById('stickyAtc');
  if (!atcBtn || !sticky) return;
  var io = new IntersectionObserver(function(entries) {
    sticky.classList.toggle('visible', !entries[0].isIntersecting);
  }, { threshold: 0.1 });
  io.observe(atcBtn);
}

// ── Accordions ────────────────────────────────────────────────
function initAccordions() {
  document.querySelectorAll('.accordion-item__trigger').forEach(function(trigger) {
    trigger.addEventListener('click', function() {
      var item   = trigger.closest('.accordion-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.accordion-item').forEach(function(i) { i.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });
}

// ── Viewing Counter ───────────────────────────────────────────
function initViewingCounter() {
  var els = document.querySelectorAll('.viewing-count');
  if (!els.length) return;
  var base = 4 + Math.floor(Math.random() * 12);
  els.forEach(function(el) { el.textContent = base; });
  setInterval(function() {
    var delta   = Math.random() > 0.5 ? 1 : -1;
    var current = parseInt(els[0].textContent) + delta;
    current = Math.max(2, Math.min(20, current));
    els.forEach(function(el) { el.textContent = current; });
  }, 8000);
}

// ── Toast ─────────────────────────────────────────────────────
function showToast(title, sub) {
  var toast = document.getElementById('lp-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.id = 'lp-toast';
    toast.className = 'toast';
    document.body.appendChild(toast);
  }
  toast.innerHTML = '<p class="toast__title">' + title + '</p><p class="toast__sub">' + sub + '</p>';
  toast.classList.add('visible');
  setTimeout(function() { toast.classList.remove('visible'); }, 3500);
}

// ── Product Forms ─────────────────────────────────────────────
function initProductForms() {
  document.querySelectorAll('.product-atc-form').forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var btn       = form.querySelector('[type="submit"]');
      var variantId = form.querySelector('[name="id"]').value;
      btn.disabled = true;
      btn.textContent = 'adding…';
      addToCart(variantId, 1).catch(function(err) {
        showToast('Error', err.message);
      }).finally(function() {
        btn.disabled = false;
        btn.textContent = 'add to cart';
      });
    });
  });
}

// ── Quick Add ─────────────────────────────────────────────────
function quickAdd(variantId) {
  addToCart(variantId, 1).catch(function(e) {
    showToast('Error', e.message);
  });
}

// ── Sticky ATC add ────────────────────────────────────────────
function stickyAddToCart() {
  var input = document.getElementById('variantInput');
  if (!input) return;
  addToCart(input.value, 1).catch(function(e) { showToast('Error', e.message); });
}

// ── Variant Selector ──────────────────────────────────────────
function initVariantSelector() {
  var product = window.productJSON;
  if (!product || !product.variants) return;
  var variants = product.variants;

  // Track currently selected option values per position
  var selectedOptions = {};
  document.querySelectorAll('.option-btn.active').forEach(function(btn) {
    selectedOptions[btn.getAttribute('data-option-pos')] = btn.getAttribute('data-option-val');
  });

  document.querySelectorAll('.option-btn').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var pos = btn.getAttribute('data-option-pos');
      var val = btn.getAttribute('data-option-val');

      // Update active button in this option group
      document.querySelectorAll('.option-btn[data-option-pos="' + pos + '"]').forEach(function(b) {
        b.classList.remove('active');
      });
      btn.classList.add('active');
      selectedOptions[pos] = val;

      // Update the label showing current selection
      var label = document.getElementById('optLabel' + pos);
      if (label) label.textContent = val;

      // Build ordered options array (position 1, 2, 3...)
      var optionValues = [];
      var positions = Object.keys(selectedOptions).sort();
      positions.forEach(function(p) { optionValues.push(selectedOptions[p]); });

      // Find matching variant
      var matched = null;
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var match = true;
        for (var j = 0; j < optionValues.length; j++) {
          if (v.options[j] !== optionValues[j]) { match = false; break; }
        }
        if (match) { matched = v; break; }
      }

      if (matched) applyVariant(matched);
    });
  });
}

function applyVariant(variant) {
  // Update all hidden variant inputs
  document.querySelectorAll('#variantInput, [name="id"]').forEach(function(el) {
    el.value = variant.id;
  });

  // Update price display
  var priceEl   = document.getElementById('variantPrice');
  var compareEl = document.getElementById('variantCompare');
  var saveEl    = document.getElementById('variantSave');

  if (priceEl) priceEl.textContent = formatMoney(variant.price);

  if (variant.compare_at_price && variant.compare_at_price > variant.price) {
    if (compareEl) { compareEl.textContent = formatMoney(variant.compare_at_price); compareEl.style.display = ''; }
    if (saveEl) {
      var pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
      saveEl.textContent = pct + '% off';
      saveEl.style.display = '';
    }
  } else {
    if (compareEl) compareEl.style.display = 'none';
    if (saveEl) saveEl.style.display = 'none';
  }

  // Update ATC buttons
  var atcBtn    = document.getElementById('atcBtn');
  var stickyBtn = document.getElementById('stickyAtcBtn');
  var label     = variant.available ? 'add to cart' : 'sold out';
  [atcBtn, stickyBtn].forEach(function(btn) {
    if (!btn) return;
    btn.disabled = !variant.available;
    btn.textContent = label;
  });

  // Update Buy Now link
  var buyNow = document.getElementById('buyNowBtn');
  if (buyNow) buyNow.href = '/checkout?variant=' + variant.id + '&quantity=1';

  // Update sticky price
  var stickyPrice = document.getElementById('stickyPrice');
  if (stickyPrice) {
    stickyPrice.textContent = formatMoney(variant.price);
    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      stickyPrice.innerHTML = formatMoney(variant.price) +
        '&nbsp;<s style="color:var(--text-muted);font-size:11px">' + formatMoney(variant.compare_at_price) + '</s>';
    }
  }

  // Swap main image if variant has its own image
  if (variant.featured_image) {
    var imgSrc  = variant.featured_image.src;
    var mainImg = document.getElementById('mainProductImg');
    if (mainImg && mainImg.src !== imgSrc) {
      var full = new Image();
      full.onload = function() {
        mainImg.style.opacity = '0';
        mainImg.style.transition = 'opacity 0.2s ease';
        setTimeout(function() { mainImg.src = imgSrc; mainImg.style.opacity = '1'; }, 50);
      };
      full.src = imgSrc;
    }
  }

  // Update URL without reload
  if (window.history && window.history.replaceState) {
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    } catch(e) {}
  }
}

// ── Init ──────────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function() {
  fetchCart().then(renderCart);
  initAnnouncementBar();
  initCountdown('#product-countdown');
  initCountdown('#banner-countdown');
  initMobileGallery();
  initDesktopGallery();
  initStickyAtc();
  initAccordions();
  initViewingCounter();
  initProductForms();
  initVariantSelector();

  // Social proof popup — delayed
  setTimeout(function() {
    showSocialPopup();
    setInterval(showSocialPopup, 30000);
  }, 9000);
});
